// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"251":"checkout","353":"contact","884":"admin"}[chunkId] + "." + {"251":"21988a55","353":"39210691","884":"61873d80"}[chunkId] + ".css";
};